import React from 'react';

import MPMContext from './MPMContext';
import { MPMReducer } from './MPMReducer';
import { AUTH_LOGOUT, DEFAULT_APP_LANGUAGE, SET_USER_DATA, SET_TOGGLE_MENU } from '../Constants';

const GlobalState = props => {

    const [myState, dispatch] = React.useReducer(MPMReducer, {
        bigMenu: true,
        isAuthenticated: false,
        selectedLanguage: DEFAULT_APP_LANGUAGE,
        connectedUser: {},
    });

    const stateLogout = (data) => {

        dispatch({ type: AUTH_LOGOUT, data });
    };

    const stateSetUserData = (data) => {
        dispatch({ type: SET_USER_DATA, data });
    };

    const stateToggleMenu = (data) => {
        dispatch({ type: SET_TOGGLE_MENU, data });
    };

    return (
        <MPMContext.Provider value={{
            bigMenu: myState.bigMenu,
            isAuthenticated: myState.isAuthenticated,
            connectedUser: myState.connectedUser,
            selectedLanguage: myState.selectedLanguage,
            setUserData: stateSetUserData,
            logout: stateLogout,
            toggleMenu: stateToggleMenu,
        }}>
            {props.children}
        </MPMContext.Provider>
    );
}

export default GlobalState;